module.exports = __webpack_public_path__ + "static/media/hardhat.c5aaf799.svg";